import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-cross",
  "use": "icon-cl-cross-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cl-cross\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.502 2.51a.73.73 0 0 0 0 1.021l4.54 4.617-4.249 4.321a.73.73 0 0 0 0 1.02.701.701 0 0 0 1.004 0l4.248-4.32 4.158 4.229a.701.701 0 0 0 1.004 0 .73.73 0 0 0 0-1.02l-4.158-4.23 4.45-4.525a.73.73 0 0 0 0-1.021.701.701 0 0 0-1.005 0L8.046 7.127 3.505 2.51a.701.701 0 0 0-1.003 0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol